import { IJob } from '@wix/media-platform-js-client/dist/mjs/src/platform/management/job/job';
import { Action } from '../redux.types';
import { StringMap } from '../../types/system';
import { JobEventPayload, JOBS_ACTION_NAMES } from './jobs.actions';

export type JobsState = StringMap<IJob<any>>;

const defaultState: JobsState = {};

export const jobs = (
  state: JobsState = defaultState,
  { type, payload }: Action,
): JobsState => {
  switch (type) {
    case JOBS_ACTION_NAMES.JOB_STARTED:
    case JOBS_ACTION_NAMES.JOB_STATUS_CHANGED: {
      const { job }: JobEventPayload<any> = payload;

      if (!job.id) {
        return state;
      }

      return {
        ...state,
        [job.id]: job,
      };
    }

    default:
      return state;
  }
};
